import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a20a4f84")

_pushScopeId("data-v-a20a4f84")
const _hoisted_1 = { class: "ExpressMultiTemplate" }
const _hoisted_2 = { class: "ExpressMultiTemplate__actions" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Создать новый заказ ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Создать заказ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_express_city = _resolveComponent("express-city")!
  const _component_express_sender_panel = _resolveComponent("express-sender-panel")!
  const _component_express_sender = _resolveComponent("express-sender")!
  const _component_express_receiver_panel = _resolveComponent("express-receiver-panel")!
  const _component_express_invoice_form = _resolveComponent("express-invoice-form")!
  const _component_express_multi_tariffs = _resolveComponent("express-multi-tariffs")!
  const _component_express_area_limit = _resolveComponent("express-area-limit")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_express_city, {
      class: "ExpressMultiTemplate__block",
      "selected-city": _ctx.state.selected_city,
      disabled: _ctx.isActionsDisabled,
      onSubmit: _ctx.onCitySelect
    }, null, 8, ["selected-city", "disabled", "onSubmit"]),
    (!_ctx.isSenderSelected)
      ? (_openBlock(), _createBlock(_component_express_sender_panel, {
          key: 0,
          class: "ExpressMultiTemplate__block",
          city: _ctx.state.selected_city,
          onSelect: _ctx.onSenderSelect
        }, null, 8, ["city", "onSelect"]))
      : (_openBlock(), _createBlock(_component_express_sender, {
          key: 1,
          class: "ExpressMultiTemplate__block",
          sender: _ctx.state.selected_sender,
          disabled: _ctx.isActionsDisabled,
          onReset: _ctx.onSenderReset
        }, null, 8, ["sender", "disabled", "onReset"])),
    _createVNode(_component_express_receiver_panel, {
      class: "ExpressMultiTemplate__block",
      city: _ctx.state.selected_city,
      "selected-receivers-ids": _ctx.state.invoices.map((invoice) => invoice.id),
      disabled: _ctx.isActionsDisabled,
      onSelect: _ctx.onReceiverSelect
    }, null, 8, ["city", "selected-receivers-ids", "disabled", "onSelect"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invoices, (invoice, i) => {
      return (_openBlock(), _createBlock(_component_express_invoice_form, {
        class: "ExpressMultiTemplate__block",
        key: `ExpressInvoice-${i}`,
        invoice: invoice,
        index: i + 1,
        tasks: _ctx.tasks_state.tasks,
        "is-tasks-loading": _ctx.tasks_state.is_tasks_loading,
        "is-tasks-failed": _ctx.tasks_state.is_tasks_failed,
        items: invoice.items,
        "is-tariff-selected": Boolean(_ctx.selectedTariffId),
        "selected-tariff-price": _ctx.selectedTariffPrice,
        "is-additional-data": !_ctx.state.invoices[i].is_additional_data_setted,
        disabled: _ctx.isActionsDisabled,
        "amount-to-accept-payment": _ctx.state.invoices[i].amount_to_accept_payment,
        "extra-info": _ctx.state.invoices[i].extra_info,
        "verification-type": _ctx.state.invoices[i].verification_type,
        "verification-invoice-number": _ctx.state.invoices[i].verification_invoice_number,
        onDelete: _ctx.onInvoiceRemove,
        onReloadTasks: _ctx.loadTasks,
        onSelectTask: _ctx.onSelectTask,
        onUnselectTask: _ctx.onUnselectTask,
        onAddItem: _ctx.onAddItem,
        onRemoveItem: _ctx.onRemoveItem,
        onSubmitAdditionalData: _ctx.onSubmitAdditionalData,
        onResetAdditionalData: _ctx.onResetAdditionalData
      }, null, 8, ["invoice", "index", "tasks", "is-tasks-loading", "is-tasks-failed", "items", "is-tariff-selected", "selected-tariff-price", "is-additional-data", "disabled", "amount-to-accept-payment", "extra-info", "verification-type", "verification-invoice-number", "onDelete", "onReloadTasks", "onSelectTask", "onUnselectTask", "onAddItem", "onRemoveItem", "onSubmitAdditionalData", "onResetAdditionalData"]))
    }), 128)),
    _createVNode(_component_express_multi_tariffs, {
      class: "ExpressMultiTemplate__block",
      loading: _ctx.tariffs_state.is_loading,
      failed: _ctx.tariffs_state.is_failed,
      disabled: _ctx.isActionsDisabled,
      tariffs: _ctx.tariffs_state.tariffs,
      "error-text": _ctx.tariffs_state.error_text,
      distance: _ctx.tariffs_state.distance,
      "selected-tariff-id": _ctx.selectedTariffId,
      onReload: _ctx.loadTariffs,
      onSelect: _ctx.onSelectTariff
    }, null, 8, ["loading", "failed", "disabled", "tariffs", "error-text", "distance", "selected-tariff-id", "onReload", "onSelect"]),
    _createVNode(_component_express_area_limit, { class: "ExpressMultiTemplate__block" }),
    _createVNode("div", _hoisted_2, [
      (_ctx.state.is_order_created)
        ? (_openBlock(), _createBlock(_component_s_button, {
            key: 0,
            class: "blue",
            onClick: _ctx.resetState
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_s_button, {
        class: "blue",
        disabled: _ctx.state.is_order_created,
        loading: _ctx.state.is_creating_order,
        onClick: _ctx.createOrder
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ])
  ]))
})